var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',{staticClass:"navbar-brand--cej",attrs:{"href":_vm.homeRota}},[_c('b',{staticClass:"logo-icon"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/images/logo-icon.png"),"alt":"homepage"}})]),_c('span',{staticClass:"logo-text"},[_c('p',[_vm._v("Lições para toda a vida!")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }